import { render } from "./PasswordResetRequest.vue?vue&type=template&id=38388d5f&scoped=true"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=js"

import "./PasswordResetRequest.vue?vue&type=style&index=0&id=38388d5f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38388d5f"]])

export default __exports__